import React from "react"
import { useDispatch, useSelector } from "react-redux"
import { useParams } from "react-router-dom"
import ListPage from "../../../../../../../../../../../../components/v2/layout/listPage/listPage"
import BlockFormModal from "./components/blockFormModal"
import BlockDialog from "./components/blockDialog"
import {
  clearBlocksList,
  createBlock,
  deleteBlock,
  getBlocksList,
  updateBlock,
} from "../../../../../../../../../../../../library/store/actions/creators/groupsCreators"
import BlockCard from "../../../../../../../../../../../../components/v2/layout/cards/blockCard"
import useCreator from "../../../../../../../../../../../../hooks/useCreator"

const SegmentSectionBlocks = () => {
  const dispatch = useDispatch()
  const params = useParams()
  const creator = useCreator()

  const { sectionBlocksList, sectionBlocksListEndReached } = useSelector(
    ({ groups }) => groups
  )

  const onCreateBlock = async (data) => await creator(createBlock(data))
  const onEditBlock = async (data) => await creator(updateBlock(data))
  const onDeleteBlock = async (id) => await creator(deleteBlock({ id }))

  return (
    <ListPage
      title={"Section Blocks"}
      creationButtonTitle={"Create Block"}
      noResultsLabel={"This section doesn't have blocks yet"}
      getList={async ({ name, offset }) =>
        await dispatch(
          getBlocksList({
            section_id: parseInt(params.sectionId, 10),
            name,
            offset,
          })
        )
      }
      clearList={() => dispatch(clearBlocksList())}
      list={sectionBlocksList}
      listEndReached={sectionBlocksListEndReached}
      getListItemComponent={({
        item,
        openEditDialog,
        openDeletionDialog,
        openInfoDialog,
      }) => (
        <BlockCard
          block={item}
          openDeleteBlock={openDeletionDialog}
          openEditBlock={openEditDialog}
          openBlockDetails={openInfoDialog}
          key={item.id}
        />
      )}
      getFormDialogComponent={({ open, onClose, activeItem }) => {
        return (
          <BlockFormModal
            open={open}
            handleClose={onClose}
            onSubmit={!activeItem ? onCreateBlock : onEditBlock}
            activeBlock={activeItem}
            edit={!!activeItem}
            isForSection
            updateList={async () =>
              await dispatch(
                getBlocksList({
                  section_id: parseInt(params.sectionId, 10),
                  offset: 0,
                })
              )
            }
          />
        )
      }}
      getDeletionDialogComponent={{
        entityName: "block",
        onDelete: onDeleteBlock,
      }}
      getInfoDialogComponent={({ open, onClose, activeItem }) => (
        <BlockDialog open={open} onClose={onClose} activeBlock={activeItem} />
      )}
    />
  )
}

export default SegmentSectionBlocks
